module.exports = __webpack_public_path__ + "static/media/HL2.2989bc0c.jpg";